/**
 * @desc 获取仓库明细
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.WarehouseParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/warehouse/listAll`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
